export const AUDIENCES_FILTER_OPTIONS = "audiencesFilterOptions";
export const WEATHER_TRIGGERS = "weatherTriggers";
export const CRICKET_TRIGGERS = "cricketTriggers";
export const CAMPAIGN_DETAILS = "campaignDetails";
export const FILTERED_SCREENS = "filteredScreens";
export const CREATIVES_DATA = "creatives";
export const PRICING_DATA = "pricingData";
export const FILTERED_SCREENS_IN_FILTER_FIVE = "filteredFive";

// used for creatives
export const ALL_NETWORK_LIST = "ALL_NETWORK_LIST";
export const ALL_BRAND_LIST = "ALL_BRAND_LIST";
export const ALL_PACKAGE_LIST = "ALL_PACKAGE_LIST";

// campaign page
export const CAMPAIGN_CREATION_STATUS = "campaignCreationStatus";
export const UPLOAD_CREATIVE_SCREEN_DATA = "uploadCreativeScreenData";
export const ALL_CAMPAIGNS_LIST = "allCampaignsList";

// used for planning page

export const LANDING_PAGE_DATA = "landingPageData";

export const FULL_CAMPAIGN_PLAN = "fullCampaignPlan";
// 1
export const CURRENT_STEP = "currentStep";
export const CAMPAIGN = "campaign";
// 2
export const AUDIENCE_DATA = "audienceData";
export const TOTAL_SCREEN_COST_DATA = "totalScreenCostData";
export const SELECTED_AUDIENCE_TOUCHPOINTS = "selectedAudienceTouchpoints";
// 3
export const ADVANCE_FILTER_SCREENS_MAP_DATA = "advanceFilterScreensMapData";
export const SELECTED_SCREENS_ID = "selectedScreensId";
// 4
export const REGULAR_VS_COHORT_PRICE_DATA = "regularVsCohortPriceData";
export const COST_SUMMARY = "costSummary";
// 5
export const SCREEN_SUMMARY_DATA = "screenSummaryData";
export const SCREEN_SUMMARY_TABLE_DATA = "screenSummaryTableData";
export const SCREEN_SUMMARY_SELECTION = "screenSummarySelection";
export const SCREEN_TYPE_TOGGLE_SELECTION = "screenTypeToggleSelection"
// 6
export const SELECTED_TRIGGER = "selectedTrigger";

// 7
export const CAMPAIGN_CREATIVES = "campaignCreatives";

export const FOOTER_DATA = "footerData";
